import { Env as Envlib } from '@region-lib/env';
/**
 * All environment variables use in project based on different env setup
 */

const { API_HOST, COOKIE_DOMAIN, TOKEN_KEY, HOST } = Envlib;

export const ENV = `${process.env.ENVIRONMENT}`;
export const isProduction = `${process.env.ENVIRONMENT}` === 'production';
export const isTestnet = `${process.env.ENVIRONMENT}` === 'testnet';
export const isTest = `${process.env.ENVIRONMENT}` === 'test';
export const isDev = `${process.env.ENVIRONMENT}` === 'dev';
export const isLocal = `${process.env.ENVIRONMENT}` === 'local';

export const getHostnameSuffix = () => {
  if ((isProduction || isTestnet) && process.browser) {
    const hostnameSplits = location.hostname.split('.');
    return hostnameSplits.slice(hostnameSplits.length - 2).join('.');
  }
  return 'zoomex.com';
};

const REPLACE_DOMAIN_WHITE_LIST = [];

export const replaceDomainUrl = (url: string) => {
  if (!isProduction && !isTestnet && !url) {
    return url;
  }

  const hostnameSuffix = getHostnameSuffix();
  const domainSplits = url
    .replace(/^https?\:\/\//, '')
    .split('/')[0]
    .split('.');
  const domainSuffix = domainSplits.slice(domainSplits.length - 2).join('.');
  if (
    REPLACE_DOMAIN_WHITE_LIST.some((whiteDomainSuffix) =>
      domainSuffix.includes(whiteDomainSuffix)
    )
  ) {
    return url.replace(new RegExp(domainSuffix, 'g'), hostnameSuffix);
  }
  return url;
};

export const apiHost = API_HOST;
export const imgBasePath = `${process.env.BASE_PATH}`;
export const basePath = `${process.env.BASE_PATH}`;
export const zoomexBuildEnv = `${process.env.AUTH_ENV}`;
export const cookieDomain = COOKIE_DOMAIN;
export const authTokenName = TOKEN_KEY;
export const learnHost = process.browser ? location.origin : `${HOST}/media`;
export const mainSiteUrl = HOST;

export const mediaPrefix = '/media';
export const defaultCategory = 'news';

export const CONTENTSTACK_GRAPHQL_ENDPOINT = `https://graphql.contentstack.com/stacks/${process.env.CONTENTSTACK_LEARN_API_KEY}?environment=${process.env.CONTENTSTACK_ENV}`;
